import { Loader2Icon } from 'lucide-react';

import { cn } from '@/lib/utils';

interface SpinnerProps extends React.ComponentProps<'svg'> {
  spinning?: boolean;
}

function Spinner({ className, spinning = true, ...props }: SpinnerProps) {
  return (
    <Loader2Icon
      role="status"
      aria-label="Loading"
      className={cn('size-4', spinning && 'animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
